import axios from 'axios';
import { GET_ALL_GROUPS } from './actionTypes';
import { Constants } from '../../constants';

// eslint-disable-next-line import/prefer-default-export
export const getAllGroups = (page, limit) => (dispatch) => {
  axios
    .get(`${Constants.apiPath}/groups/datatables`, {
      params: {
        page,
        limit,
      },
    })
    .then((res) => {
      dispatch({
        type: GET_ALL_GROUPS,
        payload: {
          data: res.data.data,
          totalSize: res.data.recordsFiltered,
        },
      });
    })
    .catch((e) => {
      console.log(e.message);
    });
};
